import RSAKey from '@/utils/rsa/rsa.js';

/**
 * RSA setting
 * @returns {uIdRsa, pwdRsa, newPwdRsa}
 */
function setRSA(rsaData, id, pwd, newPwd) {
  let resultObj = {};

  const rsa = new RSAKey();
  rsa.setPublic(rsaData.rsaModulus, rsaData.rsaExponent);

  resultObj.uIdRsa = rsa.encrypt(id);
  resultObj.pwdRsa = rsa.encrypt(pwd);
  if (arguments.length > 3) resultObj.newPwdRsa = rsa.encrypt(newPwd);

  return resultObj;
}

/**
 * RSA setting - no id
 * @returns {pwdRsa, newPwdRsa}
 */
function setRSANoId(rsaData, pwd) {
  let resultObj = {};

  const rsa = new RSAKey();
  rsa.setPublic(rsaData.rsaModulus, rsaData.rsaExponent);

  resultObj.pwdRsa = rsa.encrypt(pwd);

  return resultObj;
}

export { setRSA, setRSANoId };
